import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { SnackBarType } from '../models/Snackbar';
import { SnackBarComponent } from '../components/snackbar/snackbar.component';

@Injectable({
  providedIn: 'root'
})
export class SnackBarService {

  constructor(private _snackBar: MatSnackBar, private _translate: TranslateService) { }
  
  callSnackBar(message: string, type: SnackBarType, duration: number = 4000, verticalPosition: any = 'bottom', horizontalPosition: any = 'right', interpolationParameters?: any) { 
    const config: MatSnackBarConfig = {
        duration: duration,
        horizontalPosition: horizontalPosition,
        verticalPosition: verticalPosition,
        panelClass:[this.getSnackBarColor(type)]
    }
    this._translate.get(message ?? 'ERROR', interpolationParameters).subscribe((res) => {
      this._snackBar.openFromComponent(SnackBarComponent,{ data: res, ...config });
    });
  }

  private getSnackBarColor(type: SnackBarType) {
        switch (type) {
            case SnackBarType.ERROR: return 'error-snackbar';
            case SnackBarType.WARNING: return 'warning-snackbar';
            case SnackBarType.SUCCESS: return 'success-snackbar';
        }
  }
}